import { Component, Input, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'w-field',
    template: `
  <span class="b-view-panel__field-label" [ngClass]="{'is-error': isError}" [innerHTML]="label"></span>
  <span class="b-view-panel__field-value" [style.display]="valueAsBlock ? 'block': ''"><ng-content></ng-content></span>`,
    // if not label, no space before value, if none present, add a space so get displayed (empty line)
    styles: [`
  .b-view-panel__field-label:not(:empty):after, .b-view-panel__field-value:empty:after  {
    content: '\\00A0'
  }
  `],
    host: {
        class: 'b-field b-view-panel__field'
    },
    standalone: false
})
/*
@id w-field
@name w-field
@status release
@description Read-only field (label+content)
*/
export class WFieldComponent {
  @Input() label: string = ''; // field label
  @Input() isError: boolean = false; // field represents error (label shown red)
  @Input() valueAsBlock: boolean = false; // display value in block element (new line, full width)
}
@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [WFieldComponent],
  declarations: [WFieldComponent]
})
export class WFieldModule { }
